module.exports = __webpack_public_path__ + "static/media/SWSCRC6-19.6b5e21b9.mp3";